import { IAction } from '@Root/types'
import { IUploadedAvatar } from '@Utils/AvatarUploader'

import {
  ISubscription,
  ISubscriptionReference,
} from '@SiteModules/Subscription/types'

import {
  IWorkspaceData,
} from '@SiteModules/Workspace/types'

export const AccountActionTypes = {
  RESET_CURRENT_ACCOUNT: '@@account/RESET_CURRENT_ACCOUNT',
  FETCH_WORKSPACES: '@@workspace/FETCH_WORKSPACES',
  FETCH_WORKSPACES_SUCCESS: '@@workspace/FETCH_WORKSPACES_SUCCESS',
  FETCH_WORKSPACES_FAILURE: '@@workspace/FETCH_WORKSPACES_FAILURE',
  SET_CURRENT_ACCOUNT: '@@account/SET_CURRENT_ACCOUNT',
  RENAME_ACCOUNT: '@@account/RENAME_ACCOUNT',
  RENAME_ACCOUNT_SUCCESS: '@@account/RENAME_ACCOUNT_SUCCESS',
  RENAME_ACCOUNT_FAILURE: '@@account/RENAME_ACCOUNT_FAILURE',
  SET_UPLOADING_AVATAR: '@@account/SET_UPLOADING_AVATAR',
  CHANGE_AVATAR: '@@account/CHANGE_AVATAR',
  CHANGE_AVATAR_SUCCESS: '@@account/CHANGE_AVATAR_SUCCESS',
  CHANGE_AVATAR_FAILURE: '@@account/CHANGE_AVATAR_FAILURE',
  CHANGE_TRANSLATION_PROVIDER_CREDENTIALS: '@@account/CHANGE_TRANSLATION_PROVIDER_CREDENTIALS',
  CHANGE_TRANSLATION_PROVIDER_CREDENTIALS_SUCCESS: '@@account/CHANGE_TRANSLATION_PROVIDER_CREDENTIALS_SUCCESS',
  CHANGE_TRANSLATION_PROVIDER_CREDENTIALS_FAILURE: '@@account/CHANGE_TRANSLATION_PROVIDER_CREDENTIALS_FAILURE',
  MOVE_PROJECTS_TO_OTHER_WORKSPACE: '@@account/MOVE_PROJECTS_TO_OTHER_WORKSPACE',
  MOVE_PROJECTS_TO_OTHER_WORKSPACE_SUCCESS: '@@account/MOVE_PROJECTS_TO_OTHER_WORKSPACE_SUCCESS',
  MOVE_PROJECTS_TO_OTHER_WORKSPACE_FAILURE: '@@account/MOVE_PROJECTS_TO_OTHER_WORKSPACE_FAILURE'
}

export interface IAccountState {
  readonly accounts: IAccount[]
  readonly currentAccountId: number
  readonly saving: boolean
  readonly hasRenamedAccountSuccessfully: boolean
  readonly uploadingAvatar: boolean
  readonly isUpdatingSubscription: boolean
}

export interface IAccount {
  readonly id: number
  readonly lastUsedWorkspaceId?: number
  readonly attributes: IAccountAttributes
  readonly subscription?: ISubscription
}

export interface IAccountData {
  readonly id: string
  readonly type: 'account'
  readonly attributes: IAccountAttributes
  readonly relationships: IAccountRelationships
}

export interface IAccountAttributes {
  readonly name: string
  readonly maxFileSize: number | null
  readonly remainingElementStorageSpace: number
  readonly usedElementStorageSpace: number
  readonly maxElementStorageSpace: number
  readonly availableTotalCredits: number
  readonly availableAnalysisCredits: number
  readonly canGetTrial: boolean
  readonly isNew: boolean
  readonly stripeTaxPercent: number
  readonly stripeCurrency?: string
  readonly userIsAdmin: boolean
  readonly adminEmails: string[]
  readonly workspaceIds: number[]
  readonly maxNumberOfAccountUsers: number
  readonly avatarUrl?: string
  readonly translationProvider: string
  readonly translationProviderId: string | null
  readonly translationProviderSecret: string | null
  readonly creditPricePerHour: number
}

export interface IAccountRelationships {
  readonly subscription: {
    readonly data?: ISubscriptionReference
  }
}

export interface IFetchWorkspacesPayload {
  accountId: number
}

export interface IFetchWorkspacesSuccessResponseBody {
  readonly data: IWorkspaceData[]
}

export interface ISetCurrentAccountPayload {
  readonly accountId: number
}

export interface IRenameAccountPayload {
  readonly accountId: number
  readonly name: string
}

export type IRenameAccountSuccessPayload = IRenameAccountPayload

export interface IChangeAvatarPayload extends IUploadedAvatar {
  readonly accountId: number
}

export type IChangeAvatarSuccessPayload = IChangeAvatarPayload

export interface IChangeTranslationProviderCredentialsPayload {
  readonly accountId: number
  readonly translationProviderId: string | null
  readonly translationProviderSecret: string | null
  readonly translationProvider?: string
}

export type IChangeTranslationProviderCredentialsSuccessPayload = IChangeTranslationProviderCredentialsPayload

export interface IMoveProjectsToOtherWorkspacePayload {
  readonly accountId: number
  readonly workspaceId: number
  readonly projectIds: string[]
}

export type TAccountActionTypes =
  IAction<IFetchWorkspacesSuccessResponseBody> |
  IAction<ISetCurrentAccountPayload> |
  IAction<IRenameAccountSuccessPayload> |
  IAction<IChangeAvatarSuccessPayload> |
  IAction<IChangeTranslationProviderCredentialsSuccessPayload>
